import { Col, Row } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import PaymentReceiptWorker from "./PaymentReceiptWorker";
import WalletTabelWrker from "./WalletTabelWrker";
import Walletworker from "./Walletworker";
import { Button, Space } from "antd";
import InputDate from "../../../../components/inputs/InputDate";
import ModalFinancialReport from "./ModalFinancialReport";
import { Collapse } from "antd";
import Paycheck from "./Paycheck";

export default function FinanceWorker({ data }) {
  const [showModalFinancialReport, setShowModalFinancialReport] =
    useState(false);
  const [fromDate, setFromDate] = useState(undefined);
  const [toDate, setToDate] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const { Panel } = Collapse;

  const openFinancialModal = () => {
    setShowModalFinancialReport(true);
  };

  const handleClodeModalFinancialReport = () => {
    setShowModalFinancialReport(false);
  };

  const handelValueFromDate = (name, value) => {
    setFromDate(value);
  };

  const handelValueToDate = (name, value) => {
    setToDate(value);
  };

  const reset = () => {
    setFromDate(undefined);
    setToDate(undefined);
  };

  return (
    <section>
      {showModalFinancialReport ? (
        <ModalFinancialReport
          showitem={showModalFinancialReport}
          handleCloseMoudal={() => handleClodeModalFinancialReport()}
          userId={data}
          fromDate={fromDate}
          toDate={toDate}
        />
      ) : null}

      <Row>
        <WalletTabelWrker id={data} />

        <div style={{ marginTop: 20 }} className='col-md-12'>
          <Collapse style={{ marginTop: 15 }} defaultActiveKey={["0"]}>
            <Panel header='گزارش مالی' key='1'>
              <div style={{ display: "flex" }}>
                <div className='col-md-6'>
                  <InputDate
                    label='از تاریخ'
                    name='fromDate'
                    defaultValue={fromDate}
                    handelValue={handelValueFromDate}
                  />
                </div>
                <div className='col-md-6'>
                  <InputDate
                    label='تا تاریخ'
                    name='toDate'
                    defaultValue={toDate}
                    handelValue={handelValueToDate}
                  />
                </div>
              </div>

              <div className='row' style={{ display: "flex", marginTop: 20 }}>
                <div className='col-md-6'>
                  <Button
                    type='danger'
                    style={{ width: "100%" }}
                    loading={loading}
                    onClick={() => openFinancialModal()}
                  >
                    گزارش مالی
                  </Button>
                </div>
                <div className='col-md-6'>
                  <Button
                    type='primary'
                    danger
                    ghost
                    style={{ width: "100%" }}
                    onClick={() => reset()}
                  >
                    پاک کردن فرم جستجو
                  </Button>
                </div>
              </div>
            </Panel>
          </Collapse>
        </div>

        {/* <div style={{ marginTop: 20 }} className="col-md-12">
                    <Button
                        type="danger"
                        style={{ width: '100%' }}
                        //loading={loading}
                        onClick={() => openFinancialModal()}
                    >
                        گزارش مالی
                    </Button>
                </div> */}

        <Col md='12' lg='12' sm='12' xs='12' className='mt-4'>
          <h4 className='mb-4'>
            رسید های قابل پرداخت
          </h4>

          <PaymentReceiptWorker />
        </Col>
        <Col md='12' lg='12' sm='12' xs='12' className='mt-5'>
          <hr />
          <h4 className='mb-4'>
            کیف پول نیرو
          </h4>
          <Walletworker />
        </Col>
        <Col md='12' lg='12' sm='12' xs='12' className='mt-5'>
          <hr />
          <h4 className='mb-4'>
            فیش حقوقی
          </h4>
          <Paycheck id={data} />
        </Col>
      </Row>
    </section>
  );
}
